import { render } from "./PlusIcon.vue?vue&type=template&id=dc502aec"
import script from "./PlusIcon.vue?vue&type=script&lang=js"
export * from "./PlusIcon.vue?vue&type=script&lang=js"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__